/**
 * @file        ringBuffer.js
 * @author      Wes Garland, wes@kingsds.network, Original author 
 *              Arnab Sagar, arnab@kingsds.network
 * @date        Mar 2022 
 * 
 * Implementation of an N-slot ring buffer (circular list). Methods are largely modelled after methods
 * of Array. Iteration methods (eg map) use insertion order as enumeration order.
 *
 * Methods:
 * - push
 * - clear
 * - remove
 * - head
 * - forEach
 * - map
 * - filter
 * - find
 * - slice
 * - indexOf
 * - reduce
 * Properties:
 * - size
 * - count
 */
'use strict';

exports.RingBuffer = RingBuffer;

/**
 * RingBuffer constructor
 *
 * @param {number} size      number of elements in the RingBuffer
 */
function RingBuffer(size)
{
  this.size = size;
  this.clear();
}

RingBuffer.prototype.push = function RingBuffer$$push(el)
{
  this.buf[this.next] = el;
  this.next = (this.next + 1) % this.size;
  this.count++;
}

RingBuffer.prototype.clear = function RingBuffer$$clear()
{
  this.buf = [];
  this.next = 0;
  this.count = 0;
}

RingBuffer.prototype.remove = function RingBuffer$$remove(index)
{
  this.buf.splice(index, 1);
  // need to move the next back if it's at the end of the buffer
  if (this.next > this.buf.length)
    this.next = this.buf.length;
}

RingBuffer.prototype.head = function RingBuffer$$head()
{
  if (this.next === 0)
    return this.buf.length !== this.size ? undefined : this.buf[this.size - 1];
  return this.buf[this.next - 1];
}

for (let method of ['forEach', 'map', 'filter', 'find', 'slice', 'indexOf', 'reduce'])
{
  RingBuffer.prototype[method] = function RingBuffer$$autoMethod()
  {
    var top    = this.buf.slice(this.next);
    var bottom = this.buf.slice(0, this.next);
    var tmp = top.concat(bottom);
  
    return tmp[method].apply(tmp, arguments);
  }
}
